export default function (Alpine) {
    Alpine.store('city', {
        id: null,
        name: '',

        init(state) {
            if (state?.id) {
                this.id = state.id;
                this.name = state.name;
            }
        },

        async set(cityId, cityName) {
            const app = Alpine.store('app');

            const res = await fetch(app.routes.city.change, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': app.csrf,
                    'Accept': 'application/json',
                },
                body: JSON.stringify({ city_id: cityId }),
            });

            if (!res.ok) {
                throw await res.json();
            }

            // источник истины для UI — выбор пользователя
            this.id = cityId;
            this.name = cityName;
            window.dispatchEvent(
                new CustomEvent('city:changed', {
                    detail: { id: cityId, name: cityName }
                })
            );
        }
    });
}
